export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
export const CERTIFICATE_MODULE = "CertificateModule";
export const SHARE_MODAL = "ShareModal";
export const CONTACT_DETAILS_MODAL = "ContactDetailsModal";
export const SOCIAL_SHARE_MODAL = "SocialShareModal";
export const ASK_A_QUESTION = "AskaQuestionModal";
export const SHARE_YOUR_DETAIL_MODAL = "ShareYourDetailModal";

export const REVIEW_MODAL = "RatingReviewModal";
export const EMAIL_SHARE_MODAL = "EmailShareModal";

export const EMAIL_MODAL = "EmailModal";
export const ACTIVITY_MAP_DISCLIAMER = "ActivityMapDisclaimer";
export const RECOMMENDATION_MODAL = "RecommendationModal";

export function showModal(type, ownProps) {
  // const scrollPosition =
  //   window.pageYOffset || document.documentElement.scrollTop;
  // console.log("scrollPosition", scrollPosition);

  return {
    type: SHOW_MODAL,
    modalType: type,
    ownProps,
  };
}

export function hideModal() {
  return {
    type: HIDE_MODAL,
    modalType: null,
  };
}
